<template>
  <main-input-dialog
    :is-visible.sync="computedIsVisible"
    :inputs="dialogInputs"
    agree-text="button.send"
    dialog-width="40%"
    :title-translation="$i18n.t('dialog.title.sendSms')"
    :loading="isLoading"
    @agree="sendBillingMessageHandler"
  >
    <template #messageText.input="slot">
      <v-col>
        <v-row no-gutters>
          <v-col cols="12">
            <data-input class="textarea--custom" v-model="messageValue" v-bind="slot" :rules="slot.rules"></data-input>
          </v-col>
        </v-row>
      </v-col>
    </template>
    >
  </main-input-dialog>
</template>
<script>
import { call } from 'vuex-pathify';
import DataInput from '@/components/DataInput';
export default {
  name: 'SendBillingsMessageDialog',
  components: {
    DataInput,
    MainInputDialog: () => import('@/components/MainInputDialog'),
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    selectedFeatures: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.messageValue = '';
        this.$emit('update:isVisible', nV);
      },
    },
    dialogInputs() {
      return [
        {
          name: 'messageText',
          translationPath: 'dialog.body.messageText',
          subtitle: 'dialog.body.messageTextSubtitle',
          cols: '12',
          dataType: {
            name: 'textarea',
          },
          rows: 1,
          autoGrow: true,
          rules: [v => !!v || v === undefined || 'rules.required'],
        },
      ];
    },
  },
  data: () => ({
    isLoading: false,
    messageValue: '',
  }),
  methods: {
    sendSms: call('billings/sendSms'),
    async sendBillingMessageHandler() {
      try {
        this.isLoading = true;
        await this.sendSms({
          watermeter_ids: this.selectedFeatures,
          message_text: this.messageValue,
        });
        this.isLoading = false;
        this.computedIsVisible = false;
      } catch {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style lang="scss">
.textarea--custom {
  textarea {
    max-height: 400px;
  }
}
</style>
